import { render } from "./BaseTop.vue?vue&type=template&id=25c69541&scoped=true"
import script from "./BaseTop.vue?vue&type=script&lang=js"
export * from "./BaseTop.vue?vue&type=script&lang=js"

import "./BaseTop.vue?vue&type=style&index=0&id=25c69541&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c69541"]])

export default __exports__